export default __webpack_public_path__ + "static/media/vaz.fb8f37df.jpg";